;
import { ViewController, Slides, ModalController, Platform } from 'ionic-angular';
import { Component, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the ImageModalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-image-modal',
  templateUrl: 'image-modal.html',
})
export class ImageModalPage {

  @ViewChild('slides') slides: Slides;
  imageSrcs: Array<string> = []
  currentIndex: number = 0;
  currentPage: number = 0;
  imageCount: number = 0;
  isShowAll: boolean = true;
  imageWidth: number = 0;
  showSlide: boolean = false;

  constructor(public navCtrl: NavController, public navParams: NavParams, private currentVC: ViewController, private platform: Platform,
    private cdRef: ChangeDetectorRef) { }

  ionViewDidEnter() {
    if (this.navParams.get("imageSrcs") != null
    && this.navParams.get("slideIndex") != null) {
      this.currentIndex = this.navParams.get("slideIndex");
      this.currentPage = this.currentIndex + 1;
      this.imageSrcs = this.navParams.get("imageSrcs");
      this.imageCount = this.imageSrcs.length;
      this.isShowAll = this.navParams.get("isShowAll");

      if (this.isShowAll) {
        this.showSlide = true;
        setTimeout(() => {
          this.slides.lockSwipes(true);
          this.cdRef.detectChanges();
        }, 350);
      } else {
        if (this.currentIndex == 0) {
          this.showSlide = true;
          setTimeout(() => {
            this.slides.lockSwipes(true);
            this.cdRef.detectChanges();
          }, 350);
        } else {
          setTimeout(() => {
            this.showSlide = true;
            this.cdRef.detectChanges();
          }, 350);
        }
      }
      this.imageWidth = this.platform.width();
    }
  }

  slideChange() {
    this.currentIndex = this.slides.getActiveIndex();
    // prevents exceeding display of currentPage
    if ((this.currentIndex + 1) <= this.imageCount) {
      this.currentPage = this.currentIndex + 1;
    }
    this.slides.lockSwipes(true);
  }

  slideToPrevious() {
    this.slides.lockSwipes(false);
    this.slides.slidePrev();
  }

  slideToNext() {
    this.slides.lockSwipes(false);
    this.slides.slideNext();
  }

  closePreview() {
    this.currentVC.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/image-modal/image-modal.ts